import { FieldError } from 'react-hook-form';
import { FC } from 'react';

import { TermostatstyringGulv } from '../../../../../utils/registerEnums';

import { EnumRadioButton } from './enumRadioButton';
import { EnumRadioGroup } from './enumRadioGroup';

interface Props {
  onChange: (value: TermostatstyringGulv) => void;
  error?: FieldError;
  value?: TermostatstyringGulv;
}

export const TermostatstyringGulvvarme: FC<Props> = ({ onChange, error, value }) => (
  <EnumRadioGroup
    error={error}
    value={value}
    labelKey="register.termostatstyring.gulvvarme.label"
    helperTextKey="register.termostatstyring.gulvvarme.information"
    onChange={(value) => onChange(value as TermostatstyringGulv)}
  >
    <EnumRadioButton i18nPrefix="register" value={TermostatstyringGulv.Trinnbryter} />
    <EnumRadioButton i18nPrefix="register" value={TermostatstyringGulv.TrinnlosRegulering} />
    <EnumRadioButton i18nPrefix="register" value={TermostatstyringGulv.TermostatstyrtUtenTidsstyring} />
    <EnumRadioButton i18nPrefix="register" value={TermostatstyringGulv.TermostatstyrtMedTidsstyring} />
    <EnumRadioButton i18nPrefix="register" value={TermostatstyringGulv.Ukjent} />
  </EnumRadioGroup>
);
